var ItemCard = Backbone.View.extend({
    events: {},
    initialize: function(){
        _.bindAll( this, 'render' );

        this.listenTo( this.model, 'change', this.render );
    },
    render: function(){

        if ( this.model.get( 'visible' ) ) {
            this.$el.removeClass( 'd-none' );
        } else {
            this.$el.addClass( 'd-none' );
        }
    }
});

export {ItemCard};